import { BaseMessage } from './base.js';
export class PeerAnnounceUserInfoMessage extends BaseMessage {
    payload;
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    get userId() {
        return this.payload.userId;
    }
    get name() {
        return this.payload.name;
    }
}
